function Footer() {
  return (
    <footer className="footer">
      <p>2023 Ⓒopyright Dusan Madjar | All Rights Reserved</p>
    </footer>
  );
}

export default Footer;
